






































































































import DueDateChip from "@/components/project/DueDateChip.vue";
import TicketAcknowledgeDialog from "@/components/project/TicketAcknowledgeDialog.vue";
import AssigneePreview from "@/components/utility/AssigneePreview.vue";
import Debug from "@/components/utility/Debug.vue";
import PaginatedTable from "@/components/utility/v2/PaginatedTable.vue";
import { TicketStatusEnum } from "@/lib/enum/ticket-status.enum";
import { PageFilterOperationEnum } from "@/lib/utility/data/page-filter-operation.enum";
import { formatYearsMonthDay, simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import { $t } from "@/lib/utility/t";
import { TicketGoToHelper } from "@/lib/utility/ticket.go-to-helper";
import PartnerFallbackMixin from "@/mixins/PartnerFallbackMixin.vue";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { IPageFilterElement, PageFilterElement } from "@/models/page-filter-element.entity";
import { Project } from "@/models/project.entity";
import { IReference } from "@/models/reference.entity";
import { ITag } from "@/models/tag.entity";
import { ITicket } from "@/models/ticket.entity";
import { Vehicle } from "@/models/vehicle.entity";
import { BackendResourceEnum } from "@/store/enum/authResourceEnum";
import { VehicleAccessLayer } from "@/store/modules/access-layers/vehicle.access-layer";
import { UserModule } from "@/store/modules/me-user.store";
import { ProjectModule } from "@/store/modules/project.store";
import { TicketModule } from "@/store/modules/ticket.store";
import { VehicleModule } from "@/store/modules/vehicle.store";
import { predefinedTicketFilter } from "@/views/project/filter/PredefinedTicketFilter";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import { DataTableCompareFunction } from "vuetify";
import TagPreview from "../tag/TagPreview.vue";
import ConfirmActionDialog from "../utility/ConfirmActionDialog.vue";
import RefsCompanyAddress from "../utility/RefsCompanyAddress.vue";
import RefsList from "../utility/RefsList.vue";
import RefsProject from "../utility/RefsProject.vue";
import RefsTicket from "../utility/RefsTicket.vue";
import { IControlElements, ITableWrapperHeader } from "../utility/TableWrapper.vue";
import Tooltip from "../utility/tooltip.vue";
import TicketCreateDialog from "./TicketCreateDialog.vue";
import TicketSideCard from "./TicketSideCard.vue";
import { PredefinedFilterType } from "@/views/event/filter/event.filter";

@Component({
  components: {
    PaginatedTable,
    ConfirmActionDialog,
    TicketAcknowledgeDialog,
    TicketCreateDialog,
    TicketSideCard,
    RefsProject,
    RefsTicket,
    RefsCompanyAddress,
    AssigneePreview,
    RefsList,
    DueDateChip,
    TagPreview,
    Debug,
    Tooltip
  },
  filters: { simpleDoubleDigitDate }
})
export default class TicketTable extends mixins(PartnerFallbackMixin, PermissionMixin) {
  readonly store = TicketModule;

  readonly BackendResourceEnum = BackendResourceEnum;

  @Prop()
  partnerId!: string;

  @Prop({ default: false })
  hideCreateButton?: boolean;

  @Prop({ default: () => [] })
  refs!: IReference[];

  @Prop({ default: () => [] })
  filters!: IPageFilterElement[];

  @Prop()
  controlElements?: IControlElements[] | undefined;

  @Prop({ default: false })
  showVehicleHeader?: boolean;

  @Prop({ default: () => [] })
  tags!: ITag[];

  selectedItems: ITicket[] = [];

  selectedItem: ITicket | null = null;

  selectedItemForDelete: ITicket | null = null;

  isDialogActive = false;

  isDeleteDialogActive = false;

  isDeleteLoading = false;

  get ticketStateMap() {
    return TicketModule.ticketStateMap;
  }

  get quickFilters(): PredefinedFilterType[] {
    const quickFilters: PredefinedFilterType[] = [];

    quickFilters.push({
      name: "project.ticket.mine",
      filter: [
        new PageFilterElement({
          key: "assignees",
          value: UserModule.userId,
          operation: PageFilterOperationEnum.EQUAL
        })
      ]
    });

    quickFilters.push({
      name: "components.FilterCardPagination.predefinedFilter.ticket.open",
      filter: [
        new PageFilterElement({
          key: "state",
          operation: PageFilterOperationEnum.EQUAL,
          value: TicketStatusEnum.OPEN
        })
      ]
    });

    quickFilters.push({
      name: "project.ticket.overdue",
      filter: [
        new PageFilterElement({
          key: "due",
          operation: PageFilterOperationEnum.LESS_EQUAL,
          value: formatYearsMonthDay(new Date())
        }),
        new PageFilterElement({
          key: "state",
          operation: PageFilterOperationEnum.EQUAL,
          value: TicketStatusEnum.OPEN
        })
      ]
    });

    return quickFilters;
  }

  get predefinedFilter() {
    const predefinedFilter = predefinedTicketFilter.slice();

    return predefinedFilter;
  }

  get headers(): ITableWrapperHeader[] {
    const headers: ITableWrapperHeader[] = [];

    headers.push({
      text: "",
      value: "state",
      width: "50px",
      align: "start"
    });

    headers.push({
      text: this.$t("project.ticket.number").toString(),
      value: "number",
      width: "100px",
      align: "start"
    });

    headers.push({
      text: this.$t("objects.report.timestamp.created").toString(),
      value: "timestamp.created",
      width: "120px",
      type: "date"
    });

    headers.push({
      text: this.$t("project.ticket.assignees").toString(),
      value: "assignees",
      align: "start",
      width: "200px"
    });

    headers.push({
      text: this.$t("project.ticket.due").toString(),
      value: "due",
      width: "120px",
      align: "start",
      sort: this.sortByDue
    });

    headers.push({
      text: this.$t("project.ticket.title").toString(),
      value: "title",
      align: "start",
      width: "300px"
    });

    if (this.showVehicleHeader) {
      headers.push({
        text: this.$t("common.nouns.vehicle").toString(),
        value: "vehicleRefs",
        align: "start",
        width: "200px"
      });
    }
    headers.push({ text: $t("tag.tags"), align: "start", value: "tags", width: 280 });
    headers.push({ text: $t("objects.ticket.projectId"), align: "end", value: "projectId", width: 280 });
    headers.push({ text: "", align: "end", value: "controls", width: 120, sortable: false });

    return headers;
  }

  get _controlElements(): IControlElements[] {
    if (this.controlElements) {
      return this.controlElements;
    }

    const controlElements: IControlElements[] = [
      {
        icon: "mdi-open-in-new",
        text: $t("report.ThgChargingStationDetailCard.toDetail"),
        action: (selectedItem: ITicket) =>
          new TicketGoToHelper(this.$router).goToTicketDetail({
            ticketId: selectedItem.id,
            partnerId: selectedItem.partnerId,
            newTab: true
          })
      }
    ];

    if (this.can(this.ActionEnum.DELETE, this.ResourceEnum.TICKET)) {
      controlElements.push({
        icon: "mdi-trash-can",
        text: $t("delete"),
        action: this.onDeleteItem
      });
    }

    return controlElements;
  }

  beforeMount() {
    const combinedFilters = [...this.filters];

    // Add tag filtering if tags are provided
    if (this.tags.length > 0) {
      for (const tag of this.tags) {
        combinedFilters.push(
          new PageFilterElement({
            key: "tagIds",
            value: tag.id,
            operation: PageFilterOperationEnum.EQUAL
          })
        );
      }
    }

    TicketModule.setFilters(combinedFilters);
  }

  async getProject(id: string) {
    if (!id) return;
    let project = ProjectModule.maps.id.get(id)[0];
    if (!project) {
      project = new Project({ partnerId: this.partnerId, id });
      project.fetch();
    }

    return project;
  }

  projectName(id: string) {
    const project = ProjectModule.maps.id.get(id);

    return project?.[0]?.title ?? "";
  }

  simpleDoubleDigitDate(date: string) {
    return simpleDoubleDigitDate(date);
  }

  setSelectedItem(item: ITicket | null) {
    this.selectedItem = null;

    this.$nextTick(() => {
      this.selectedItem = item;
      this.$emit("openSideCard", item);
    });
  }

  async onDeleteItem(item: ITicket) {
    this.selectedItemForDelete = item;
    this.isDeleteDialogActive = true;
  }

  async onDelete() {
    this.isDeleteLoading = true;

    await this.selectedItemForDelete
      ?.delete()
      .then(() => {
        this.isDeleteLoading = false;
        this.isDeleteDialogActive = false;
        this.$toast.success("👍");
      })
      .catch(handleError);
  }

  get tableSortDesc() {
    return (this.$refs.table as PaginatedTable<any, any>)?.tableSortDesc;
  }

  sortByDue: DataTableCompareFunction<string> = (a: string, b: string) => {
    const desc = this.tableSortDesc ?? false;

    const hasA = !!a;
    const hasB = !!b;

    // If table implements descending by reversing sorted array, pre-compensate:
    // Put missing at top for descending request so reversal keeps them at bottom.
    if (!hasA && !hasB) return 0;
    if (!hasA && hasB) return desc ? -1 : 1;
    if (hasA && !hasB) return desc ? 1 : -1;

    const timeA = new Date(a).getTime();
    const timeB = new Date(b).getTime();
    if (timeA === timeB) return 0;
    // Always sort ascending by date; rely on table's internal reversal for descending
    return timeA < timeB ? -1 : 1;
  };

  async openDetail(item: ITicket) {
    this.$emit("openSideCard", item);
  }

  async getVehicleById(refId: string) {
    const module = VehicleModule;

    let found = module.maps.id.get(refId)[0] ?? module.paginationList.find(e => e.id === refId);

    if (!found) {
      const newEntity = new Vehicle({ id: refId, partnerId: this.partnerId });
      newEntity.loading = true;
      VehicleAccessLayer.set(newEntity);
      await newEntity.fetch();
      found = newEntity;
    }

    return found;
  }

  openCreateDialog() {
    this.isDialogActive = true;
  }
}
